(function () {
    "use strict";

    angular.module("app").directive("requestRemark", RequestRemarkFactory);

    RequestRemarkFactory.$inject = ["webApiServices", "notificationService",];
    function RequestRemarkFactory(webApiServices, notificationService) {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: false,
            scope: {
                allRemarks: "=",
                remarkName: "@",
                requestPublicId: "@",
                isValidTranslation: "@",
                isInValidTranslation: "@",
                validationRequired: "@",
                formRequired: "@",
                onValidated: "=?",
                isReadOnly: "=?",
                multiLine: "="
            },
            template: `
                <div>
                    <div class="row">
                        <div class="pull-left">
                            <label
                            ng-style="getLabelStyle()"
                            ng-click="setToggle(false)">
                                {{ isInValidTranslation }}</label>&nbsp; &nbsp;
                            <label class="switch">
                              <input type="checkbox" ng-disabled="isReadOnly">
                              <span class="slider round" ng-style="getSpanStyle()"></span>
                            </label>&nbsp; &nbsp;
                            <label
                                ng-style="getLabelStyle()"
                                ng-click="setToggle(true)">
                            {{ isValidTranslation }}</label>
                        </div>
                        <div class="pull-right"
                             style="display: flex;
                                    align-items: center;"
                             ng-if="!remark.IsValid">
                            <label i18n="Label_SimpleText" style="margin-top: 5px; cursor: pointer;" ng-click="remark.IsHtml = false"></label>
                            &nbsp; &nbsp;
                            <habil-switch ng-model="remark.IsHtml"></habil-switch>
                            &nbsp; &nbsp;
                            <label i18n="Label_RichText" style="margin-top: 5px; cursor: pointer;" ng-click="remark.IsHtml = true"></label>
                        </div>
                    </div>
                    <div class="row" ng-if="!remark.IsValid && !allowMultiLine && !isReadOnly">
                        <input class="form-control" type="text" style="width: 100%;"
                            ng-model="remark.Remark"
                            ng-change="validateSection(false)"
                            ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }">
                        <div style="color:red" ng-if="!remark.Remark">
                            <div style="border-top: 3px solid red">
                                {{ formRequired }}
                            </div>
                        </div>
                    </div>
                    <div class="row" ng-if="!remark.IsValid && allowMultiLine && !isReadOnly && !remark.IsHtml">
                        <textarea class="form-control" rows="5" type="text" style="resize: vertical;"
                            ng-model="remark.Remark"
                            ng-change="validateSection(false)"
                            ng-model-options="{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }"></textarea>
                        <div style="color:red" ng-if="!remark.Remark">
                            <div style="border-top: 3px solid red">
                                {{ formRequired }}
                            </div>
                        </div>
                    </div>
                    <div class="row" ng-if="!remark.IsValid && allowMultiLine && !isReadOnly && remark.IsHtml">
                        <rich-text-editor
                            ng-model="remark.Remark"
                            ng-change="validateSection(false)"></rich-text-editor>
                        <div style="color:red" ng-if="!remark.Remark">
                            <div style="border-top: 3px solid red">
                                {{ formRequired }}
                            </div>
                        </div>
                    </div>
                    <div class="row" ng-if="!remark.IsValid && isReadOnly">
                        <pre ng-bind-html="remark.Description"></pre>
                    </div>
                </div>`,
            link: function ($scope, element) {
                const defaultLabel = { "position": "relative", "top": "5px" };
                const notAllowedCursor = { "cursor": "not-allowed" };
                const pointerCursor = { "cursor": "pointer" };
                const backgroundGrey = { "background-color": "rgb(119 119 119 / 35%)" };

                if (angular.isDefined($scope.multiLine))
                    $scope.allowMultiLine = $scope.multiLine;

                $scope.getLabelStyle = () => $scope.isReadOnly ? { ...notAllowedCursor, ...defaultLabel } : { ...pointerCursor, ...defaultLabel };
                $scope.getSpanStyle = () => $scope.isReadOnly ? { ...notAllowedCursor, ...backgroundGrey } : { ...pointerCursor };

                $scope.remark = _.find($scope.allRemarks, { SectionName: $scope.remarkName });
                $scope.remarkIndex = _.findIndex($scope.allRemarks, $scope.remark);

                $scope.GetRemark = function () {
                    if (!$scope.allRemarks && !$scope.remarkName)
                        return;

                    return _.find($scope.allRemarks, { SectionName: $scope.remarkName });
                };

                if (!$scope.remark) $(element).remove();
                const toggle = $(element).find("input[type=checkbox]")[0];
                if ($scope.remark && $scope.remark.IsValid) $(toggle).prop("checked", true);

                $(toggle).change(function () {
                    if ($scope.isReadOnly)
                        return;

                    $scope.validateSection(this.checked);
                    $scope.$digest();
                });

                $scope.setToggle = function (isValid) {
                    if ($scope.isReadOnly || $scope.remark.IsValid === isValid)
                        return;

                    const toggle = $(element).find("input[type=checkbox]")[0];
                    $(toggle).prop("checked", isValid);
                    $scope.validateSection(isValid);
                };

                $scope.validateSection = function (isValid) {
                    const rIndex = _.findIndex($scope.allRemarks, $scope.remark);
                    if (isValid)
                        $scope.remark.Remark = null;

                    $scope.remark.ChosenCode = isValid ? $scope.remark.ValidCode : $scope.remark.InValidCode;
                    $scope.remark.IsValid = isValid;

                    const createUpdatePayload = {
                        RequestId: $scope.requestPublicId,
                        Remark: {
                            PublicId: $scope.remark.PublicId,
                            ValidCode: $scope.remark.ValidCode,
                            InValidCode: $scope.remark.InValidCode,
                            Section: $scope.remark.ChosenCode,
                            IsHtml: $scope.remark.IsHtml,
                            Description: $scope.remark.Remark
                        }
                    };

                    $scope.allRemarks[rIndex] = $scope.remark;

                    webApiServices.SaveRequestRemark(
                        createUpdatePayload,
                        angular.noop,
                        (error) => DoShowError(notificationService, error)
                    );

                    if (angular.isFunction($scope.onValidated)) {
                        $scope.onValidated($scope.GetRemark());
                    }
                };
            },
        };
    }
})();